<template>
  <v-container>
    <v-img
      v-if="!isMobile()"
      alt="Logo"
      class="bg-logo"
      contain
      :src="require('../assets/logo-talk.png')"
      transition="scale-transition"
    />
    <div class="home" style="z-index: 0;">
      <v-row justify="center" align-self="center">
        <v-col cols="12" md="9" align-self="center" justify="center" class="mt-md-10 mb-md-0">
          <h1 style="font-size: 5vh; text-shadow: 1px 1px black; color: #8799ab;">
            <span style="color: #4e5c6a">T</span>rain my
            <span style="color: #4e5c6a">S</span>ocial 
            <span style="color: #4e5c6a">S</span>kills <br> 
            <span style="color: #4e5c6a">W</span><span style="font-size: 30px;">at wil je doen?</span> 
          </h1>
        </v-col>
        <v-col cols="12" md="3" align-self="center" justify="center" class="mt-md-10 mb-md-0">
          <iframe 
            style="border-radius: 10px;"
            width="270" 
            height="140" 
            src="https://www.youtube.com/embed/ubnDMTUui1Y" 
            title="Happy Music" 
            frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen>
          </iframe>
        </v-col>
      </v-row>
      <!-- <img alt="Vue logo" src="../assets/logo.png"> -->
      <!-- <router-link to="/about">Ik wil grenzen stellen</router-link> | 
      <router-link to="/about">Ik wil gewaardeerd worden</router-link> | 
      <router-link to="/about">Ik wil gemeen zijn</router-link> | 
      <router-link to="/about">Ik wil iets doen</router-link> | 
      <router-link to="/about">Ik voel me eenzaam</router-link> | 
      <router-link to="/about">Wat voel ik?</router-link> |  -->
      <v-row>
        <v-col cols="6" lg="3" class="my-md-2 px-md-5" v-for="data in HomeButtons" :key="data.id" >
          <page-button
            :project="{
            id: data.id,
            name: data.name,
            img: data.img,
            sub: data.subtitle,
            link: data.link,
            disabled: data.disabled
            }"/>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import PageButton from '../components/PageButton.vue'
import HomeButtons from '@/assets/json/HomeButtons.json'

export default {
  name: 'Home',
  data(){
    return{
      HomeButtons: HomeButtons.powerpoints,
    }
  },
  components: {
    PageButton
  },
  methods: {
  isMobile() {
    if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      return true
    } else {
      return false
    }
  },
  }
}
</script>

<style scoped>
.bg-logo{
  position: absolute;
  height: 500px;
  width: 500px;
  opacity: 0.1;
  bottom: 0vh;
  right: 10vw;
  z-index: 0;
}
</style>